import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters'
Vue.use(Vuex);
const files = require.context('./modules', false, /\.js$/)
const modules: Record<string, Object> = {}
files.keys().forEach((key) => {
  if (key === "./index.js") return
  const moduleName = key.replace(/(\.\/|\.js)/g, '')
  modules[moduleName] = {
    namespaced: true,
    ...files(key).default
  }
})
export default new Vuex.Store({
  getters,
  modules: {
    ...modules
  },
});
